var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"secure"}},[_c('router-view',{on:{"authenticated":_vm.setAuthenticated}}),_c('div'),_c('h1',[_vm._v("Secure Area")]),_c('p',[_vm._v(" This is a secure area ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }